/**
 * @ngdoc controller
 * @name editableField.controller:EditableFieldsServiceController
 * @description
 * Manages the state of a single editable field group
 */
// @ngInject
module.exports = function ($scope, $timeout, EditableFieldsService) {
    var $field;
    var inputs = [];

    this.EDIT = EditableFieldsService.EDIT;
    this.SAVE = EditableFieldsService.SAVE;
    this.CANCEL = EditableFieldsService.CANCEL;

    // Retreives and returns the editable state of this controller
    this.isActive = function () {
        return EditableFieldsService.getFieldState($field) === EditableFieldsService.EDIT;
    };

    // Retreives and returns the current state of this controller's `field_data` object
    this.getState = function () {
        return EditableFieldsService.getFieldState($field);
    };

    // Registers this controller's field element with the EditableFieldsService
    // Also finds the input elements within the field
    this.addField = function (field) {
        $field = field;
        inputs = $field[0].querySelectorAll('input');
        EditableFieldsService.addField(field);
    };

    // Mark a field as active and editable
    this.beginEditing = function () {
        $timeout(function () {
            EditableFieldsService.setFieldState($field, EditableFieldsService.EDIT);
        });
    };

    // Mark a field as inactive and readonly
    this.endEditing = function () {
        $timeout(function () {
            EditableFieldsService.setFieldState($field, EditableFieldsService.SAVE);
        });
    };

    // Mark a field as inactive and readonly
    this.cancelEditing = function () {
        $timeout(function () {
            EditableFieldsService.setFieldState($field, EditableFieldsService.CANCEL);
        });
    };

    // Store a copy of the value of the field's input elements
    this.backupContent = function () {
        var content = Array.prototype.map.call(inputs, function (input) {
            return input.value;
        });
        EditableFieldsService.setFieldContent($field, content);
    };

    // Replace the field's input elements' values with previously stored values
    this.revertContent = function () {
        var content = EditableFieldsService.getFieldContent($field);
        if (inputs.length === content.length) {
            content.forEach(function (value, index) {
                inputs[index].value = value;
            });
        }
    };
};
